import * as styles from "./FiltersView.styles.ts";
import { observer } from "mobx-react-lite";
import { Categories } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/FiltersView/Categories/Categories.tsx";
import { FiltersFooter } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/FiltersView/FiltersFooter/FiltersFooter.tsx";
import { FiltersList } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/FiltersView/FiltersList/FiltersList.tsx";
import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";

export const FiltersView = observer(() => {
  const store = useExonnHubStore();
  const isFilterPanelOpen = store.isFilterPanelOpen;

  return (
    <>
      <div
        css={styles.outer({
          isOpen: isFilterPanelOpen,
        })}
      >
        <div css={styles.root}>
          <div css={styles.body}>
            <Categories />
            <FiltersList />
          </div>
          <FiltersFooter />
        </div>
      </div>
    </>
  );
});
